// src/logout.js
import { auth } from './firebaseConfig';
import { endSession } from './sessionManager';

export async function logout() {
  const user = auth.currentUser;
  try { await endSession(user); } catch {}
  try { await auth.signOut(); } catch {}
}
